module.exports = __webpack_public_path__ + "img/P15.9bbf61b2.png";